import React from 'react';
import {
  Image,
  TitleWrapper
} from './styled';

interface Props {
  imgSrc: string;
  text: string;
}

export const Title: React.FC<Props> = ({
  imgSrc,
  text
}) => (
  <React.Fragment>
    <Image src={imgSrc} />
    <TitleWrapper>{text}</TitleWrapper>
  </React.Fragment>
);